require('./angular');
module.exports = angular;


/*** EXPORTS FROM exports-loader ***/
module.exports = window.angular;